import { useState, useEffect, useCallback, useMemo } from 'react';
import { Polyline, FeatureGroup, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import { checkPointsInPolygons } from './LinePolygons';
import * as turf from '@turf/turf';
import { groupMarkersByVetka, groupMarkersByCanton } from '../TerritoryFilter/GroupMarkersPolygon';

const DrawingLineHandler = ({
  isLineDrawing,
  color,
  weight,
  setCoordinatesCableLine,
  cableKind,
  linePoints,
  setLinePoints,
  removeLastPoint,
  updateLength,
  switchesData = [],
  selectedCanton,
  selectedCity,
  setLengthCableSegment,
  housesData
}) => {

  const markersByVetka = useMemo(() => groupMarkersByVetka(housesData), [housesData]);
  const markersByCanton = useMemo(() => groupMarkersByCanton(switchesData), [switchesData]);

  useEffect(() => {
    if (isLineDrawing) {
      setLinePoints([]);
      setLengthCableSegment(0);
    }
  }, [isLineDrawing]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (isLineDrawing && e.key === 'Backspace') {
        removeLastPoint();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isLineDrawing, removeLastPoint]);

  const getLengthSegment = useCallback((points) => {
    let length = 0;
    for (let i = 0; i < points.length - 1; i++) {
      length += L.latLng(points[i]).distanceTo(L.latLng(points[i + 1]));
    }
    return Math.round(length);
  }, []);

  const createPointWithInfo = useCallback((latLng, lengthSegment, result) => ({
    latLng,
    polygonInfo: result.polygonInfo,
    flagTerritory: result.flagTerritory,
    lengthSegment,
    highwayCity: selectedCity
  }), [selectedCity]);

  const handleClick = useCallback((e) => {
    const clickedPoint = e.latlng;

    const result = checkPointsInPolygons(
      [{ lat: clickedPoint.lat, lng: clickedPoint.lng }],
      markersByCanton,
      markersByVetka,
      selectedCanton,
      housesData
    )[0];

    const isFirstPoint = linePoints.length === 0;
    const newPoints = isFirstPoint
      ? [clickedPoint, clickedPoint]
      : [...linePoints.slice(0, -1), clickedPoint, clickedPoint];

    const lenSegment = getLengthSegment(newPoints);

    setLinePoints(newPoints);
    updateLength(newPoints);

    if (result) {
      const pointWithInfo = createPointWithInfo(clickedPoint, lenSegment, result);
      setCoordinatesCableLine(prev =>
        isFirstPoint
          ? [pointWithInfo, pointWithInfo]
          : [...prev.slice(0, -1), pointWithInfo, pointWithInfo]
      );
    } else {
      console.warn('Invalid point returned from checkPointsInPolygons');
    }
  }, [
    isLineDrawing,
    linePoints,
    selectedCanton,
    selectedCity,
    getLengthSegment,
    updateLength,
    setLinePoints,
    setCoordinatesCableLine,
    markersByCanton,
    markersByVetka,
    housesData,
    createPointWithInfo
  ]);

  const handleMouseMove = useCallback((e) => {
    if (!isLineDrawing || linePoints.length === 0) return;

    const mousePosition = e.latlng;
    const newPoints = [...linePoints.slice(0, -1), mousePosition];
    const lenSegment = getLengthSegment(newPoints);

    setLengthCableSegment(lenSegment);
    updateLength(newPoints);
    setLinePoints(newPoints);

    const result = checkPointsInPolygons(
      [{ lat: mousePosition.lat, lng: mousePosition.lng }],
      markersByCanton,
      markersByVetka,
      selectedCanton
    )[0];

    if (result) {
      const pointWithInfo = createPointWithInfo(mousePosition, lenSegment, result);
      setCoordinatesCableLine(prev => [...prev.slice(0, -1), pointWithInfo]);
    }
  }, [
    isLineDrawing,
    linePoints,
    getLengthSegment,
    selectedCanton,
    createPointWithInfo,
    setLengthCableSegment,
    setLinePoints,
    updateLength,
    setCoordinatesCableLine,
    markersByCanton,
    markersByVetka
  ]);

  useMapEvents({
    click: (e) => {
      if (isLineDrawing) handleClick(e);
    },
    mousemove: (e) => {
      if (isLineDrawing) handleMouseMove(e);
    },
  });

  return (
    <FeatureGroup>
      {linePoints.length > 1 && (
        <Polyline
          positions={linePoints}
          color={color}
          weight={weight}
          dashArray={cableKind.trim() === 'dashed' ? '5,10' : null}
        />
      )}
    </FeatureGroup>
  );
};

export default DrawingLineHandler;

// import { useState, useEffect, useCallback } from 'react';
// import { Polyline, FeatureGroup, useMapEvents } from 'react-leaflet';
// import L from 'leaflet';
// import { checkPointsInPolygons } from './LinePolygons';
// import * as turf from '@turf/turf';
// import { groupMarkersByVetka, groupMarkersByCanton } from '../TerritoryFilter/GroupMarkersPolygon';

// const DrawingLineHandler = ({
//   isLineDrawing,
//   color,
//   weight,
//   setCoordinatesCableLine,
//   cableKind,
//   linePoints,
//   setLinePoints,
//   removeLastPoint,
//   updateLength,
//   switchesData = [],
//   selectedCanton,
//   selectedCity,
//   setLengthCableSegment,
//   housesData
// }) => {


//   const markersByVetka = groupMarkersByVetka(housesData);
//   const markersByCanton = groupMarkersByCanton(switchesData);

  
//   // Сброс при старте рисования
//   useEffect(() => {
//     if (isLineDrawing) {
//       setLinePoints([]);
//       setLengthCableSegment(0);
//     }
//   }, [isLineDrawing]);

//   // Удаление точки по Backspace
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (isLineDrawing && e.key === 'Backspace') {
//         removeLastPoint();
//       }
//     };

//     window.addEventListener('keydown', handleKeyDown);
//     return () => window.removeEventListener('keydown', handleKeyDown);
//   }, [isLineDrawing, removeLastPoint]);

//   const getLengthSegment = useCallback((points) => {
//     let length = 0;
//     for (let i = 0; i < points.length - 1; i++) {
//       const point1 = L.latLng(points[i]);
//       const point2 = L.latLng(points[i + 1]);
//       length += point1.distanceTo(point2);
//     }
//     return Math.round(length);
//   }, []);

  
//   // Хэндлер клика по карте
// //  const handleClick = useCallback((e) => {
// //   console.log('handleClick triggered', isLineDrawing);

// //   const clickedPoint = e.latlng;

// //   const result = checkPointsInPolygons(
// //     [{ lat: clickedPoint.lat, lng: clickedPoint.lng }],
// //     markersByCanton,
// //     markersByVetka,
// //     selectedCanton,
// //     housesData
// //   )[0];

// //   const isFirstPoint = linePoints.length === 0;
// //   const newPoints = isFirstPoint
// //     ? [clickedPoint, clickedPoint]
// //     : [...linePoints.slice(0, -1), clickedPoint, clickedPoint];

// //   const lenSegment = getLengthSegment(newPoints);

// //   setLinePoints(newPoints);
// //   updateLength(newPoints);

// //   if (result) {
// //     const pointWithInfo = {
// //       latLng: clickedPoint,
// //       polygonInfo: result.polygonInfo,
// //       flagTerritory: result.flagTerritory,
// //       lengthSegment: lenSegment,
// //       highwayCity: selectedCity
// //     };

// //     setCoordinatesCableLine(prev => {
// //       const newCablePoints = isFirstPoint
// //         ? [pointWithInfo, pointWithInfo]
// //         : [...prev.slice(0, -1), pointWithInfo, pointWithInfo];
// //       return newCablePoints;
// //     });
// //   } else {
// //     console.warn('Invalid point returned from checkPointsInPolygons');
// //   }
// // }, [
// //   isLineDrawing,
// //   linePoints,
// //   selectedCanton,
// //   selectedCity,
// //   getLengthSegment,
// //   updateLength,
// //   setLinePoints,
// //   setCoordinatesCableLine,
// //   markersByCanton,
// //   markersByVetka,
// //   //housesData // ← ты забыл включить это в зависимости
// // ]);
//   const handleClick = useCallback((e) => {
//     console.log('handleClick triggered', isLineDrawing);
//      if (!isLineDrawing) return;

//     const clickedPoint = e.latlng;
//     const result = checkPointsInPolygons(
//       [{ lat: clickedPoint.lat, lng: clickedPoint.lng }],
//       markersByCanton,
//       markersByVetka,
//       selectedCanton,
//       housesData
//     )[0];

//     const newPoints = [...linePoints, clickedPoint];
//     const lenSegment = getLengthSegment(newPoints);
// console.log("newPoints", newPoints);
//     setLinePoints(newPoints);
//     updateLength(newPoints);

   

//     if (result) {
//       const pointWithInfo = {
//         latLng: clickedPoint,
//         polygonInfo: result.polygonInfo,
//         flagTerritory: result.flagTerritory,
//         lengthSegment: lenSegment,
//         highwayCity: selectedCity
//       };
//       setCoordinatesCableLine(prev => [...prev, pointWithInfo]);
//     } else {
//       console.warn('Invalid point returned from checkPointsInPolygons');
//     }
//   }, [
//     isLineDrawing,
//     linePoints,
//     selectedCanton,
//     selectedCity,
//     getLengthSegment,
//     updateLength,
//     setLinePoints,
//     setCoordinatesCableLine,
//     markersByCanton,
//     markersByVetka
//   ]);

//   // Хэндлер движения мыши
//   const handleMouseMove = useCallback((e) => {
    
//     if (!isLineDrawing || linePoints.length === 0) return;

//     const mousePosition = e.latlng;
//     const newPoints = [...linePoints.slice(0, -1), mousePosition];
//     const lenSegment = getLengthSegment(newPoints);

//     setLengthCableSegment(lenSegment);
//     updateLength(newPoints);
//     setLinePoints(newPoints);

//     const result = checkPointsInPolygons(
//       [{ lat: mousePosition.lat, lng: mousePosition.lng }],
//       markersByCanton,
//       markersByVetka,
//       selectedCanton
//     )[0];

//     if (result) {
//       const pointWithInfo = {
//         latLng: mousePosition,
//         polygonInfo: result.polygonInfo,
//         flagTerritory: result.flagTerritory,
//         lengthSegment: lenSegment,
//         highwayCity: selectedCity
//       };
//       setCoordinatesCableLine(prev => [...prev.slice(0, -1), pointWithInfo]);
      
      
//     }
//   }, [
//     isLineDrawing,
//     linePoints,
//     getLengthSegment,
//     selectedCanton,
//     selectedCity,
//     setLengthCableSegment,
//     setLinePoints,
//     updateLength,
//     setCoordinatesCableLine,
//     markersByCanton,
//     markersByVetka
//   ]);

//   // Привязка событий к карте
//   useMapEvents({
//     click: (e) => {
//       if (isLineDrawing) handleClick(e);
//     },
//     mousemove: (e) => {
//       if (isLineDrawing) handleMouseMove(e);
//     },
//   });


//   return (
//     <FeatureGroup>
//       {linePoints.length > 1 && (
//         <Polyline
//           positions={linePoints}
//           color={color}
//           weight={weight}
//           dashArray={cableKind.trim() === 'dashed' ? '5,10' : null}
//         />
//       )}
//     </FeatureGroup>
//   );
// };

// export default DrawingLineHandler;

// const DrawingLineHandler = ({ isLineDrawing, color, weight, setCoordinatesCableLine, cableKind,linePoints, setLinePoints,
//                              removeLastPoint, updateLength,  switchesData = [], selectedCanton,selectedCity, setLengthCableSegment, housesData}) => {



//   useEffect(() => {
//     if (isLineDrawing) {
//       setLinePoints([]);
//       setLengthCableSegment(0);
//      } 
 
//   }, [isLineDrawing]);
  

  

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (isLineDrawing && e.key === 'Backspace') {
//         removeLastPoint();
//       }
//     };
  
//     window.addEventListener('keydown', handleKeyDown);
//     return () => {
//       window.removeEventListener('keydown', handleKeyDown);
//     };
//   }, [isLineDrawing]);

  
//        const markersByVetka = groupMarkersByVetka(housesData);
//        const markersByCanton = groupMarkersByCanton(switchesData);
    

//   useMapEvents({
//         click: (e) => {
//           if (isLineDrawing) {
//                   const clickedPoint = e.latlng;

                  
//                   const result = checkPointsInPolygons([{ lat: clickedPoint.lat, lng: clickedPoint.lng }], markersByCanton, markersByVetka, selectedCanton)[0];
//                   let lenSegment = 0;

//                   setLinePoints((prevPoints) => {
//                     const newPoints = [...prevPoints, clickedPoint];
//                    // updateLength(newPoints);
//                    updateLength([...linePoints.slice(0, -1), mousePosition]);
//                     lenSegment = LengthSegment(newPoints);
                  
//                     return newPoints;
//                   });

//                   if (result) {
//                               const pointWithInfo = {
//                                 latLng: clickedPoint,
//                                 polygonInfo: result.polygonInfo,
//                                 flagTerritory: result.flagTerritory,
//                                 lengthSegment: lenSegment,
//                                 highwayCity: selectedCity,

//                               };
//                               setCoordinatesCableLine((prevPoints) => [...prevPoints, pointWithInfo]);
//                             } else {
//                                          console.warn('Invalid point returned from checkPointsInPolygons');
//                                       } 
//                 }
//         },
//         mousemove: (e) => {
//           if (isLineDrawing) {  
//             const mousePosition = e.latlng;  
//             const lenSegment = LengthSegment(linePoints);
           
//           if (linePoints && mousePosition) {            
//             setLengthCableSegment(lenSegment);  
//           } else {
//             console.error("linePoints или mousePosition не определены.");
//           }
           
//             const result = checkPointsInPolygons([{ lat: mousePosition.lat, lng: mousePosition.lng }], markersByCanton, markersByVetka, selectedCanton)[0];
//             if (result) {
//               const pointWithInfo = {
//                 latLng: mousePosition,
//                 polygonInfo: result.polygonInfo,
//                 flagTerritory: result.flagTerritory,
//                 lengthSegment: lenSegment,
//                 highwayCity: selectedCity,
//               };
    
//               setCoordinatesCableLine(prevPoints => [...prevPoints.slice(0, -1), pointWithInfo]);
//             } else {
//                          console.warn('Invalid point returned from checkPointsInPolygons');
//                       } 

//             setLinePoints(prevPoints => [...prevPoints.slice(0, -1), mousePosition]);         
//             updateLength(linePoints);
//           }
//           }   
//       });

//       const LengthSegment = (points) => {
//         let lengthSegment = 0;
       
//         for (let i = 0; i < points.length - 1; i++) {
//           const point1 = L.latLng(points[i]);
//           const point2 = L.latLng(points[i + 1]);
//           lengthSegment = point1.distanceTo(point2);
//         }
//         return Math.round(lengthSegment);
//       };

//   return (
//     <FeatureGroup>
//       {linePoints.length > 1 && (
//         <Polyline
//           positions={linePoints}
//           color={color}
//           weight={weight}
//           dashArray={cableKind === 'dashed ' ? '5,10' : null}
//         />
//       )}
//     </FeatureGroup>
//   );
// };

// export default DrawingLineHandler;

